/* ==========================================================
   HOLY SHOP — Collection Vêtements JS (ES5 compatible)
   Swatch colors, swatch hover, category filter
   ========================================================== */

var PALETTE = {
  'noir':            '#16110F',
  'or':              '#C9A227',
  'gold':            '#C9A227',
  'rose':            '#E9B8B0',
  'rose clair':      '#E9B8B0',
  'rose poudre':     '#E9B8B0',
  'rose poudré':     '#E9B8B0',
  'light pink':      '#E9B8B0',
  'blanc':           '#F2EDE3',
  'blanc casse':     '#F2EDE3',
  'blanc cassé':     '#F2EDE3',
  'white':           '#F2EDE3',
  'sable':           '#D8C7A6',
  'natural':         '#D8C7A6',
  'bleu':            '#3B4C5A',
  'bleu ciel':       '#CBDCE6',
  'marine':          '#1B2A3D',
  'oxford marine':   '#1B2A3D',
  'gris':            '#7A7A76',
  'bordeaux':        '#6B2733',
  'grenat':          '#6B2733',
  'vert':            '#3F5F4A',
  'forest green':    '#2D4A32',
  'olive foncée':    '#3E4A2A',
  'violet':          '#5C3A7C',
  'purple':          '#5C3A7C',
  'marguerite':      '#F5E6A3',
  'camel':           '#C19A6B',
  'orange':          '#D9642A',
  'black':           '#16110F',
  'azalea':          '#E8839B',
  'azalée':          '#E8839B',
  'jaune':           '#F5D547',
  'vintage black':   '#2A2522',
  'vintage bottle green': '#2E4A3A',
  'héliconia':       '#E54B7A',
  'heliconia':       '#E54B7A',
  'rouge':           '#C62828',
  'red':             '#C62828'
};

/* ─────────── SWATCH COLORS + HOVER ─────────── */
document.querySelectorAll('.vc-card').forEach(function (card) {
  var mainImg = card.querySelector('.vc-card__photo--main');
  var hoverImg = card.querySelector('.vc-card__photo--hover');
  var swatches = [].slice.call(card.querySelectorAll('.vc-sw'));
  var mapEl = card.querySelector('[data-color-map]');

  var colorMap = {};
  if (mapEl) {
    try {
      var raw = JSON.parse(mapEl.textContent);
      delete raw._end;
      colorMap = raw;
    } catch (e) { /* ignore */ }
  }

  // Apply palette hex to swatch dots, with variant image fallback
  swatches.forEach(function (sw) {
    var hex = PALETTE[sw.dataset.color];
    if (hex) {
      sw.style.setProperty('--sw-color', hex);
    } else if (sw.dataset.variantImg) {
      sw.style.setProperty('--sw-color', 'transparent');
      sw.style.setProperty('--sw-img', 'url(' + sw.dataset.variantImg + ')');
      sw.classList.add('vc-sw--img');
    } else {
      sw.style.setProperty('--sw-color', '#ddd');
    }
  });

  // Swatch click: change card images
  swatches.forEach(function (sw) {
    sw.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var color = sw.dataset.color;
      var data = colorMap[color];

      swatches.forEach(function (x) {
        x.classList.toggle('vc-sw--active', x === sw);
        x.setAttribute('aria-pressed', String(x === sw));
      });

      if (data && mainImg) {
        if (mainImg.removeAttribute) mainImg.removeAttribute('srcset');
        mainImg.src = data.main;
        mainImg.dataset.mainSrc = data.main;
        if (hoverImg) {
          if (data.hover) {
            if (hoverImg.removeAttribute) hoverImg.removeAttribute('srcset');
            hoverImg.src = data.hover;
            hoverImg.style.display = '';
          } else {
            hoverImg.style.display = 'none';
          }
        }
      }
    });
  });
});

/* ─────────── CATEGORY FILTER ─────────── */
var pills = [].slice.call(document.querySelectorAll('[data-filter]'));

pills.forEach(function (pill) {
  pill.addEventListener('click', function () {
    pills.forEach(function (x) { x.classList.remove('vc-pill--active'); });
    pill.classList.add('vc-pill--active');

    var val = pill.dataset.filter;

    document.querySelectorAll('.vc-card').forEach(function (card) {
      var visible = val === 'all' || card.dataset.cat === val;
      card.classList.toggle('is-hidden', !visible);
    });
  });
});
